import React from 'react';
import { FileText, Zap, Wallet } from 'lucide-react';

const Dashboard = ({ user, onSelectApp }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      padding: '40px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{ marginBottom: '10px' }}>Welcome, {user.email.split('@')[0]}!</h1>
        <p style={{ color: '#666', marginBottom: '40px' }}>Select a tool to get started</p>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px'
        }}>
          {/* Marine Offer Builder Card */}
          <div
            onClick={() => onSelectApp('marine')}
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              ':hover': {
                transform: 'translateY(-5px)'
              }
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <FileText size={50} color="#4CAF50" />
            <h2 style={{ margin: '20px 0 10px' }}>Marine Offer Builder</h2>
            <p style={{ color: '#666' }}>Create offers and invoices for marine equipment</p>
            <button style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              Open App →
            </button>
          </div>

          {/* Power Plant Builder Card */}
          <div
            onClick={() => onSelectApp('power')}
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              ':hover': {
                transform: 'translateY(-5px)'
              }
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <Zap size={50} color="#FF9800" />
            <h2 style={{ margin: '20px 0 10px' }}>Power Plant Builder</h2>
            <p style={{ color: '#666' }}>Design and quote power plant solutions</p>
            <button style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#FF9800',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              Open App →
            </button>
          </div>

          {/* Finance Tracker Card */}
          <div
            onClick={() => onSelectApp('finance')}
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              ':hover': {
                transform: 'translateY(-5px)'
              }
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <Wallet size={50} color="#2563EB" />
            <h2 style={{ margin: '20px 0 10px' }}>Finance Tracker</h2>
            <p style={{ color: '#666' }}>Track payments, balances, and finance documents</p>
            <button style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              Open App →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 